import React, { useEffect, useState } from 'react';

interface PerformanceMetrics {
  loadTime: number;
  renderTime: number;
  networkTime: number;
}

const PerformanceMonitor: React.FC = () => {
  // Performance metrics disabled - return null to hide completely
  return null;
  
  // Uncomment the code below if you want to re-enable performance metrics
  /*
  const [metrics, setMetrics] = useState<PerformanceMetrics | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isHidden, setIsHidden] = useState(() => {
    // Check if user previously hid the performance metrics
    return localStorage.getItem('hidePerformanceMetrics') === 'true';
  });

  useEffect(() => {
    // Only show in development
    if (process.env.NODE_ENV !== 'development') return;

    const startTime = performance.now();

    // Monitor page load performance
    const handleLoad = () => {
      const loadTime = performance.now() - startTime;
      
      // Get navigation timing
      const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      const networkTime = navigation ? navigation.responseEnd - navigation.requestStart : 0;
      
      setMetrics({
        loadTime,
        renderTime: loadTime - networkTime,
        networkTime,
      });
    };

    // Monitor resource loading
    const handleResourceLoad = () => {
      const resources = performance.getEntriesByType('resource') as PerformanceResourceTiming[];
      const totalResourceTime = resources.reduce((total, resource) => {
        return total + (resource.responseEnd - resource.startTime);
      }, 0);

    };

    window.addEventListener('load', handleLoad);
    window.addEventListener('load', handleResourceLoad);

    // Show metrics after a delay
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => {
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('load', handleResourceLoad);
      clearTimeout(timer);
    };
  }, []);

  if (!isVisible || !metrics || process.env.NODE_ENV !== 'development' || isHidden) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-75 text-white p-4 rounded-lg text-xs font-mono z-50">
      <div className="mb-2 font-bold">Performance Metrics</div>
      <div>Load Time: {metrics.loadTime.toFixed(2)}ms</div>
      <div>Network Time: {metrics.networkTime.toFixed(2)}ms</div>
      <div>Render Time: {metrics.renderTime.toFixed(2)}ms</div>
      <button
        onClick={() => {
          setIsHidden(true);
          localStorage.setItem('hidePerformanceMetrics', 'true');
        }}
        className="mt-2 text-xs text-gray-400 hover:text-white"
      >
        Hide
      </button>
    </div>
  );
  */
};

export default PerformanceMonitor;
